export const ga_video_event = (Action, Label, playerType, embedUrl, videoLength, videoTitle, videoId, videoChannel) => {

    // const data = {
    //     event: 'video_events',
    //     Category: 'Video',
    //     Action,
    //     Label,
    //     metaData: {
    //         videoLength: getVideoLength(videoLength),
    //         videoTitle,
    //         videoId,
    //         liveBroadCast: 'no',
    //         videoChannel
    //     }
    // }

    // window.dataLayer.push(data);
}

const getVideoLength = video_length => {
    console.log(video_length);
    if (!video_length)
        return;

    const dateObj = new Date(Number(video_length) * 1000);
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getSeconds();

    const timeString = hours.toString().padStart(2, '0') + ':' +
        minutes.toString().padStart(2, '0') + ':' +
        seconds.toString().padStart(2, '0');

    return timeString;

}